// Typing indicator component - 31 lines ✅
import { Bot } from 'lucide-react'
import { cn } from '@/lib/utils'

interface TypingIndicatorProps {
  className?: string
}

export function TypingIndicator({ className }: TypingIndicatorProps): JSX.Element {
  return (
    <div
      className={cn('flex gap-3 rounded-lg bg-kaycoo-white-2 p-4', className)}
      role="status"
      aria-live="polite"
    >
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white">
        <Bot className="h-4 w-4 text-kaycoo-teal-dark" aria-hidden="true" />
      </div>
      <div className="flex items-center gap-1 pt-1">
        <span className="h-2 w-2 animate-bounce rounded-full bg-kaycoo-teal-dark [animation-delay:-0.3s]" />
        <span className="h-2 w-2 animate-bounce rounded-full bg-kaycoo-teal-dark [animation-delay:-0.15s]" />
        <span className="h-2 w-2 animate-bounce rounded-full bg-kaycoo-teal-dark" />
      </div>
      <span className="sr-only">AI is typing...</span>
    </div>
  )
}
